import React,{ Component } from 'react';
import { addCreditCardAction, paymentSuccessful } from '../../Actions/paymentAction';
import { enableLoader, disableLoader, getUserAction } from '../../Actions/index';
import {FormGroup,Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import MaskedInput from 'react-text-mask';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
//import { GetRewards } from '../../Actions/rewardsAction';
import VISA from '../../images/payment-cards/Visa.png';
import DISCOVER from '../../images/payment-cards/Discover.png';
import MASTERCARD from '../../images/payment-cards/master.png';
import AMEX from '../../images/payment-cards/americanexperss.png';
import moment from 'moment';
import {routeName} from '../../../src/Service/env';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import {audioFunc} from "../../Service/helper";

const styles={
    buttonProgress: {
        color: '#fff',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -25,
        marginLeft: -15,
    }
};

class CardForm extends Component{
    constructor(props){
        super(props);
        this.state={
           cardData:{},
            errors:[],
            loading:false
        }
    }

    handleChange=(e)=>{
        const { name,value } = e.target;
        const { cardData, errors=[] } = this.state;
        if(name==='CreditCardNo'){
            if(value.length===16) {
                cardData['CardCompany'] = this.checkCardType(value);
                if(cardData['CardCompany']) {
                    this.changeImage();
                    errors[name] = "";
                }
                else {
                    errors[name] = "Invalid card number.";
                }
            }
            else
                cardData['cardImage']= null;
        }
        if(name==='expiryDate'){
            cardData['Expire_month']=value.split('/')[0];
            cardData['Expire_year']=value.split('/')[1];
        }
        cardData[name]=value;
        this.setState({ cardData, errors })
    };

    onSubmit=()=>{
        const { cardData,errors } = this.state;
        const { Business={}, plan, history } = this.props;

        if(Object.keys(cardData).length < 8){
            errors['common']='Please fill in all the details.'
        }
        else if(Object.keys(Business).length <=0 )
            errors['common']='You have not Registered Yet.';
        else if (errors.Cvv || errors.FullName || errors.CreditCardNo || errors.expiryDate) {
        }
        else {
            errors['common'] = '';
            this.props.enableLoader();
            this.setState({
                loading:true
            });
            this.props.addCreditCardAction({
                ...cardData,
                "PlanId": plan.PlanID,
                "BusinessID": Business.BusinessUser.BusinessId,
                "withTrial":history.location.state?history.location.state.withTrial:true
            })
              .then((data) => {
                this.props.disableLoader();
                this.setState({
                    loading:false
                });
                if (data.ResponseCode) {
                    this.props.getUserAction().then((data)=>{
                      this.props.paymentSuccessful(data);
                      audioFunc(true,false,'')
                      history.push(`/${routeName}/Dashboard/Overview`)
                    })
                    //this.props.getUserAction();
                }
                else {
                    if(!Boolean(data.Message)) {
                        errors['common'] = "Server error, please try again.";
                    }
                    else {
                        errors['common'] = data.Message;
                    }
                    this.setState({ errors });
                }
            })
              .catch(()=>{
                errors['common'] = 'Something went wrong reaching server. Try Again';
                this.props.disableLoader();
                this.setState({
                    loading:false,
                    errors
                });
            });
        }
        this.setState({
            errors
        })
    };

    checkCardType=(cardNumber)=>{
        let Visa = /^4[0-9]{12}(?:[0-9]{3})?$/;
        let Amex = /^3[47][0-9]{13}$/;
        let MasterCard = /^5[1-5][0-9]{14}$/;
        let Discover = /^6(?:011|5[0-9]{2})[0-9]{12}$/;
        let Mestro = /^(5018|5020|5038|6304|6759|6761|6763)[0-9]{8,15}$/;

        if (Visa.test(cardNumber))
        {
            return "VISA";
        }
        else if (Amex.test(cardNumber))
        {
            return "AMEX";
        }
        else if (MasterCard.test(cardNumber))
        {
            return "MASTERCARD";
        }
        else if (Discover.test(cardNumber))
        {
            return "DISCOVER";
        }
        else if (Mestro.test(cardNumber))
        {
            return "MAESTRO";
        }
        else {

            return null;
        }
    };

    changeImage=()=>{
        const { cardData } = this.state;
        let cardCompany = cardData.CardCompany;
        if (cardCompany !== undefined && cardCompany !== "") {
            if (cardCompany === "VISA")
                cardData['cardImage'] = VISA;
            else if (cardCompany === "AMEX")
                cardData['cardImage'] = AMEX;
            else if (cardCompany === "MASTERCARD")
                cardData['cardImage'] = MASTERCARD;
            else if (cardCompany === "DISCOVER")
                cardData['cardImage'] = DISCOVER;
            this.setState({
                cardData
            })
        }
    };

    NumberMask=(props)=>{
        const {...other} = props;
        return(
            <MaskedInput
                {...other}
                mask={[/[1-9]/, /\d/, /\d/,/\d/, /\d/, /\d/,/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                placeholder="1234123412341234"
                guide={false}
                showMask={false}
            />
        )
    };

    cvvMask=(props)=>{
        const {...other} = props;
        return(
            <MaskedInput
                {...other}
                mask={[/[0-9]/, /\d/, /\d/]}
                placeholder="123"
                guide={false}
                showMask={false}
            />
        )
    };

    DateMask=(props)=>{
        const {...other} = props;
        return(
            <MaskedInput
                {...other}
                mask={[/[0-9]/, /\d/, '/', /[0-9]/, /\d/,/\d/, /\d/]}
                placeholder="MM/YYYY"
                guide={false}
                showMask={false}
                keepCharPositions={true}
            />
        )
    };

    validate=(e)=>{
        const { name,value } = e.target;
        let { errors,cardData } = this.state;
        if(name==='Cvv') {
            if (!value)
                errors[name] = 'Please Enter CVV Number.';
            else if(value.length<3)
                errors[name] = 'Please Enter valid CVV Number.';
            else
                errors[name] = '';
        }
        else if(name==='expiryDate') {
            let currentYear=moment().format('YYYY');
            if (!value)
                errors[name] = 'Please Enter Expiry Date.';
            else if(moment(value,'MM/YYYY').diff(moment(),'months') < 0)
                errors[name] = 'Please Enter Valid Expiry Date.';
            else if(Number(cardData['Expire_month'])< 1 || Number(cardData['Expire_month'])>12 )
                errors[name] = 'Please Enter Valid Month.';
            else if(Number(cardData['Expire_year'])< Number(currentYear) || Number(cardData['Expire_year'])> Number(currentYear)+20 )
                errors[name] = `Year should be between ${Number(currentYear)} to ${Number(currentYear)+20}.`;
            else
                errors[name]='';
        }
        else if(name==='CreditCardNo') {
            if(!errors[name]) {
                if (!value)
                    errors[name] = 'Please Enter Card Number.';
                else if(value.length<16)
                    errors[name] = 'Please Enter Valid Card Number.';
                else
                    errors[name]='';
            }
        }
        else if(name==='Fullname') {
            let namePattern = /^(?![0-9._ ]*$)[a-zA-Z0-9._ ]+$/;
            if (!value)
                errors[name] = 'Please Enter Full Name.';
            else if(!namePattern.test(value))
                errors[name] = 'Name should contains atleast 1 Alphabet and digits,dot(.),(_) or space.';
            else
                errors[name] = '';
        }
        this.setState({errors})
    };

    render(){
        const { cardData,errors,loading } = this.state;
        const { classes } = this.props;
        return(
            <div style={(loading)?{pointerEvents:'none'}:{}}>
                <Col sm={12}>
                    <FormGroup>
                        <h4 className="h4">Add Payment Information</h4>
                    </FormGroup>
                </Col>
                <Col sm={12}>
                    {(errors['common']!=='')?<span className={'error'}>{errors['common']}</span>:<span/>}
                    <FormGroup>
                        <Col sm={6} className="padding-align">
                            <label className="payment-input-labels"> Card Holder Name</label>
                            <Input
                                disableUnderline={true}
                                className='textboxControl payment-input'
                                type={'text'}
                                placeholder={'i.e. John Deo'}
                                name={'Fullname'}
                                value={cardData.Fullname}
                                onBlur={this.validate}
                                onChange={this.handleChange}
                            />
                            {(errors['Fullname']!=='')?<span className={'error'}>{errors['Fullname']}</span>:<span/>}
                        </Col>
                        <Col sm={6} className="padding-align">
                            <label className="payment-input-labels">Credit Card Number</label>
                            <Input
                                disableUnderline={true}
                                className='textboxControl payment-input'
                                type={'text'}
                                onBlur={this.validate}
                                value={cardData.CreditCardNo}
                                inputComponent={this.NumberMask}
                                onChange={this.handleChange}
                                name='CreditCardNo'
                                endAdornment={
                                    (cardData.cardImage) &&
                                    <InputAdornment position="end">
                                        <img src={(cardData.cardImage) && cardData.cardImage} width={50} height={30} style={{ marginBottom: '-10px' }}/>
                                    </InputAdornment>
                                }
                            />
                            {(errors['CreditCardNo']!=='')?<span className={'error'}>{errors['CreditCardNo']}</span>:<span/>}
                        </Col>
                    </FormGroup>
                </Col>
                <Col sm={12}>
                <FormGroup>
                    <Col sm={6} className="padding-align">
                        <label className="payment-input-labels">Expiration Date</label>
                        <Input
                            disableUnderline={true}
                            className='textboxControl payment-input'
                            type={'text'}
                            inputComponent={this.DateMask}
                            name={'expiryDate'}
                            value={cardData.expiryDate}
                            onBlur={this.validate}
                            onChange={this.handleChange}
                        />
                        {(errors['expiryDate']!=='')?<span className={'error'}>{errors['expiryDate']}</span>:<span/>}
                    </Col>
                    <Col sm={6} className="padding-align">
                        <label className="payment-input-labels">CVC</label>
                        <Input
                            disableUnderline={true}
                            className='textboxControl payment-input'
                            type={'text'}
                            name={'Cvv'}
                            inputComponent={this.cvvMask}
                            onBlur={this.validate}
                            value={cardData.Cvv}
                            onChange={this.handleChange}
                        />
                        {(errors['Cvv']!=='')?<span className={'error'}>{errors['Cvv']}</span>:<span/>}
                    </Col>
                </FormGroup>
                </Col>
                <Col sm={12}>
                    <FormGroup className="button-right">
                        <Button className="payment-btn-submit" variant={'contained'} color={'primary'} onClick={this.onSubmit}>Submit</Button>
                        {loading && <CircularProgress size={35} className={classes.buttonProgress} />}
                    </FormGroup>
                </Col>
            </div>
        )
    }
}
const mapStateToProps=(state)=> {
  return {
    user:state.loginResponse
  }
};

const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        addCreditCardAction,
        disableLoader,
        enableLoader,
        paymentSuccessful,
        //GetRewards,
        getUserAction
    },dispatch)
};
export default connect(mapStateToProps,matchDispatchToProps)(withStyles(styles)(CardForm));